import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { TextButton } from "../Button";
import "./ExpandableNumberedList.scss";

const ExpandableNumberedList = ({
    expandableList = [],
    showLessLink = "Show less",
    showMoreLink = "Show more",
    threshold = 4,
}) => {
    const [showFullText, setShowFullText] = useState(false);
    const [buttonLabel, setButtonLabel] = useState(showMoreLink);

    const toggleTextLength = () => {
        if (showFullText) {
            setShowFullText(false);
            setButtonLabel(showMoreLink);
        } else {
            setShowFullText(true);
            setButtonLabel(showLessLink);
        }
    };

    const isLongText = expandableList && expandableList.length >= threshold;

    const shortenTextContent =
        isLongText && !showFullText && "text-container-short";

    const getNumberedList = () =>
        expandableList &&
        expandableList.map((item, index) => (
            <li key={String(index) + item[0]}>{item}</li>
        ));

    return (
        <div className="expandable-container -padding-bottom--5">
            <div className={cx(`${shortenTextContent}`, "-user-html-content")}>
                <ol type="1">
                    <strong>{getNumberedList()}</strong>
                </ol>
            </div>
            {isLongText && (
                <div className="-padding-top--5">
                    <TextButton
                        handleClick={toggleTextLength}
                        styles="-font-weight--bold -cursor--pointer"
                    >
                        <small>{buttonLabel}</small>
                    </TextButton>
                </div>
            )}
        </div>
    );
};

ExpandableNumberedList.propTypes = {
    expandableList: PropTypes.arrayOf(PropTypes.string),
    showLessLink: PropTypes.string.isRequired,
    showMoreLink: PropTypes.string.isRequired,
    threshold: PropTypes.number,
};

export default ExpandableNumberedList;
